<template>
  <div :style="{width: width + 'px', height: height + 'px'}">
    <img :id="id" :src="value" />
  </div>
</template>

<script>
export default {
  props: {
    id: {type: String},
    value: {type: String},
    width: {type: Number},
    height: {type: Number}
  },
  create () {
  },
  mounted () {
    this.img = this.$el.querySelector('img')
    // console.log(this.img)
    this.changeSize()
  },
  data: function () {
    return {
      img: null
    }
  },
  name: 'UImage',
  watch: {
    value (val) {
      console.log(this.$el)
    }
  },
  methods: {
    changeSize () {
      if (this.img) {
        this.img.removeAttribute('width')
        this.img.removeAttribute('height')
      }
      // console.log(this.img)
      if (this.img.complete) {
        this.$emit('size', this.img.width + ' * ' + this.img.height)
        this.changeSizeTimeout()
      } else {
        this.img.onload = () => {
          this.$emit('size', this.img.width + ' * ' + this.img.height)
          this.changeSizeTimeout()
        }
      }
    },
    changeSizeTimeout () {
      setTimeout(() => {
        if (this.width && this.img.width > this.width) {
          this.img.height *= this.width / this.img.width
          this.img.width = this.width
        }
        if (this.height && this.img.height < this.height) {
          this.img.width *= this.height / this.img.height
          this.img.height = this.height
        }
      })
    }
  },
  computed: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/base/UImage.vue